import { render, staticRenderFns } from "./BankingIn.vue?vue&type=template&id=fa5009ba"
import script from "./BankingIn.vue?vue&type=script&lang=js"
export * from "./BankingIn.vue?vue&type=script&lang=js"
import style0 from "./BankingIn.vue?vue&type=style&index=0&id=fa5009ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports